module.exports = __webpack_public_path__ + "img/gouwuche_icon.242be9ce.png";